module.exports = __webpack_public_path__ + "img/icon-date-brow.f9c49c0d.svg";